export function convertToPersianDigits(str) {
  if (!str) return str;

  const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  const arabicDigits = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];

  return String(str)
    .replace(/[0-9]/g, (d) => persianDigits[Number(d)])
    .replace(/[٠-٩]/g, (d) => persianDigits[arabicDigits.indexOf(d)]);
}

export function formatToman(n) {
  return n.toLocaleString("fa-IR");
}
